(function (scope) {
  'use strict';
  const resolveId = (variants, id) => variants.find(v => String(v.id) === String(id || '')) || null;
  const resolveOptions = (variants, options) => {
    if (!Array.isArray(options) || options.some(x => x == null || x === '')) return null;
    return variants.find(v => v.options.length === options.length && v.options.every((x, i) => x === options[i])) || null;
  };
  const safeLabel = value => /^[\w .:-]{1,120}$/.test(String(value || '')) ? String(value) : null;
  function context(search, configuredCampaign) {
    const params = new URLSearchParams(search), out = {};
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'experiment_id']) {
      const value = safeLabel(params.get(key)); if (value) out[key] = value;
    }
    if (safeLabel(configuredCampaign)) out.campaign_id = configuredCampaign;
    return out;
  }
  function link(productUrl, id, currentUrl) {
    const current = new URL(currentUrl), url = new URL(productUrl, current.origin);
    if (url.origin !== current.origin || !/^\d+$/.test(String(id))) return null;
    for (const key of ['view', 'preview_theme_id', 'country', 'locale', 'currency']) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    Object.entries(context(current.search)).forEach(([k, v]) => url.searchParams.set(k, v));
    url.searchParams.set('variant', String(id)); return url.pathname + url.search;
  }
  const contract = Object.freeze({resolveId, resolveOptions, context, link});
  scope.CAOfferContract = contract;
  if (typeof module !== 'undefined' && module.exports) module.exports = contract;
})(typeof window === 'undefined' ? globalThis : window);
